import { t } from "i18next"
import { Badge, Col, ProgressBar } from "react-bootstrap"
import { ImageOverlay } from "react-image-overlay-effect"
import { Rest, TConfigurator } from "../../service/rest"
import { isExtendet, Settings, TAppSettings } from "../../settings"
import { Button } from "../Button/button"
import "./style.css"

type TConfiguratorProps = {
    configurator: TConfigurator
}

export const Configurator = ({configurator}:TConfiguratorProps) => {

    var buttonActive = false;
    if ((configurator.additionalData && configurator.additionalData.status === "live") ||
         configurator.extern === true){
        buttonActive = true;
    }

    const prepareLanguageList = (languages:string[]) => {
        var i = 1;
        var returnList = ""
        for(var language of languages){
            returnList += language;
            if(i<languages.length){
                returnList += ", "
            }
            i++;
        }
        return returnList
    }

    const prepareFeatureList = (features:string[]) => {
        return(features.map(feature => <Badge key={feature} className="bg-hager">{feature}</Badge>))
    }

    const getYear = (year:string|undefined) => {
        if (year){
            return `(${year})`
        }else{
            return ""
        }
    }

    const getAdminPicture = () => {
        return(
            <>
            { configurator.additionalData &&
                <ImageOverlay
                    src={configurator.pictureUrl}
                    description={
                        <span className="width">
                            <>
                                <table className="width">
                                    <tbody>
                                        <tr>
                                            <th className="bold">Status</th>
                                            <td className="light">{configurator.additionalData.status} {getYear(configurator.additionalData.year)}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}><ProgressBar label={configurator.additionalData.done+"%"}  min={0} max={100} now={configurator.additionalData.done}></ProgressBar></td>
                                        </tr>
                                        <tr>
                                            <th className="bold">Brand</th>
                                            <td className="light">{configurator.additionalData.brand}</td>
                                        </tr>
                                        <tr>
                                            <th className="bold">Languages</th>
                                            <td className="light">{prepareLanguageList(configurator.additionalData.languages)}</td>
                                        </tr>
                                        <tr>
                                            <th className="bold">Features</th>
                                            <td className="light">{prepareFeatureList(configurator.additionalData.features)}</td>
                                        </tr>
                                        <tr>
                                            <th className="bold">Brand</th>
                                            <td className="light">{configurator.additionalData.brand}</td>
                                        </tr>
                                        <tr>
                                            <th className="bold">Type</th>
                                            <td className="light">{configurator.additionalData.type}</td>
                                        </tr>
                                    </tbody>
                                </table> 
                            </>
                        </span>
                    }
                />
            }
            </>
        )
    }

    const getStatusVisualisation = (status:string|undefined) => {
        var className = "statusOther";

        switch (status){
            case "live":    className = "statusLive"; break;
            case "started": className = "statusStarted"; break;
        }

        return(
            <div className={className}>
            </div>
        )
    }

    const getUserPicture = () => {
        return (
            <div className="field-image">
                <a href={Rest.getTranslatedText(configurator.url)}>
                    {configurator.pictureUrl && <img src={configurator.pictureUrl}/>}
                </a>
            </div>
        )
    }

    const getTestUrl = () => {
        var area:TAppSettings = {key: "", name: "", start:"", suffix: ""};
        
        for (var app of Settings.environment.app){
            if (app.key == configurator.settings.type){
                area = app as TAppSettings;
                break;
            }
        }

        return Settings.environment.server + area.name + "/?theme=hager&org=" + configurator.settings.orgID + "&"+ area.start + "=" + configurator.settings.start + area.suffix
    }

    const isTestAvailable = () => {
        if (configurator.settings.noTest){
            return false
        }
        return true
    }

    const getElbridgeUrl = () =>{
        if(!configurator.additionalData || !configurator.additionalData.features || !configurator.additionalData.features.includes("ELBRIDGE 1")){
            return <></>
        }
        console.log(configurator.url)
        return (
            <>
                <h2>ELBRIDGE Url</h2>
                {getUrls().map((url)=>{return <>{url.replace("configuration.hager.com", "configuration.hager.com/elbridge")}<br/></>})}
            </>
        )
    }

    const getUrls = () => {
        if(typeof configurator.url === "string"){
            return [configurator.url]
        }

        return configurator.url.map((url)=>{return url.text})
    }

    const getConfiguratorTile = () => {
        return (
            <Col xs={12} sm={6} md={4}>
                <div className="configurator">
                    <div className="pictureContainer">
                        { !isExtendet() && getUserPicture()}
                        { isExtendet()  && getStatusVisualisation(configurator.additionalData?.status)}
                        { isExtendet()  && getAdminPicture()}
                    </div>
                    <div className="minHeigt">
                        <h2>{Rest.getTranslatedText(configurator.configuratorName)}</h2>
                        <div className="description">
                            {configurator.shortText && Rest.getTranslatedText(configurator.shortText)}
                        </div>
                        {isExtendet() && getElbridgeUrl()}
                    </div>
                      <div className="description">
                        {!isExtendet() && <Button url={Rest.getTranslatedText(configurator.url)} status={buttonActive} text={t("start")}/>}
                        {isExtendet() && <Button url={Rest.getTranslatedText(configurator.url)} status={buttonActive} text={t("production")}/>}
                        {(isExtendet() && isTestAvailable()) && <Button url={Rest.getTranslatedText(getTestUrl())} status={true} text={t("test")}/>}
                    </div>
                </div>
            </Col>
        )
    }

    return (
        <>
            { getConfiguratorTile() }
        </>
    )
}